'use strict';

class Slider {
    constructor() {
        this.slider = null;
    }

    init() {
        this.slider = document.querySelector('.tps-slider__slides');

        if (this.slider) {
            jQuery(this.slider).slick({
                dots: true,
                arrows: false,
                fade: true,
            });
        }
    }
}